import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import s from './Base44Tool.scss';
export const Base44Tool = _ref => {
  let title = _ref.title,
    description = _ref.description,
    background = _ref.background,
    _ref$light = _ref.light,
    light = _ref$light === void 0 ? false : _ref$light,
    illustration = _ref.illustration,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  return /*#__PURE__*/React.createElement(Box, {
    gap: isMobile ? '60px' : 'SP4',
    align: isMobile ? undefined : 'space-between',
    width: "100%",
    background: background,
    height: "400px",
    borderRadius: "12px",
    padding: isMobile ? '30px 18px' : '60px SP10',
    verticalAlign: isMobile ? 'top' : 'middle',
    boxSizing: "border-box",
    direction: isMobile ? 'vertical' : 'horizontal'
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "340px",
    gap: isMobile ? 'SP3' : 'SP6',
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    light: light,
    className: s.toolTitle
  }, title), /*#__PURE__*/React.createElement(Text, {
    light: light
  }, description)), isMobile ? /*#__PURE__*/React.createElement(Box, {
    className: s.mobileIllustration
  }, illustration) : illustration);
};
//# sourceMappingURL=Base44Tool.js.map